import { TYPE_BICAGAME } from "./type";

const initialState = {
  revenue: [],
};

export const reducerBicagame = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_BICAGAME:
      return {
        ...state,
        revenue: action.payload,
      };
    default:
      return state;
  }
};

